import { createSplitProps } from '../../utils/create-split-props';
export const splitPresenceProps = (props) => createSplitProps()(props, [
    'immediate',
    'lazyMount',
    'onExitComplete',
    'present',
    'unmountOnExit',
]);
